/* Pennington Publishing theme JS — deliberately tiny. Everything works without it
   (forms POST, chips are real links); this only upgrades the experience. */
(function () {
  'use strict';

  /* mobile menu */
  var btn = document.querySelector('[data-pp-menu]');
  var nav = document.getElementById('pp-nav');
  if (btn && nav) {
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* collection filters: apply ?subject= and ?grade= to the server-rendered card grid.
     Chips are real links (URL-addressable, shareable); JS intercepts them so the
     filter is instant, and rewrites the URL with history.replaceState. */
  var grid = document.querySelector('[data-pp-catalog]');
  if (grid) {
    var cards = [].slice.call(grid.querySelectorAll('.product-card'));
    var countLine = document.querySelector('[data-pp-count]');
    var chips = [].slice.call(document.querySelectorAll('.filters .chip[data-filter]'));

    var state = {
      subject: new URLSearchParams(location.search).get('subject') || 'all',
      grade: new URLSearchParams(location.search).get('grade') || 'all'
    };

    function apply() {
      var shown = 0;
      cards.forEach(function (c) {
        var subjects = (c.getAttribute('data-subject') || '').split(/\s+/);
        var grades = (c.getAttribute('data-grades') || '').split(/\s+/);
        var okS = state.subject === 'all' || subjects.indexOf(state.subject) !== -1;
        var okG = state.grade === 'all' || grades.indexOf(state.grade) !== -1;
        c.classList.toggle('pp-hidden', !(okS && okG));
        if (okS && okG) shown++;
      });
      if (countLine) countLine.textContent = shown + ' program' + (shown === 1 ? '' : 's');
      chips.forEach(function (ch) {
        var f = ch.getAttribute('data-filter').split(':');
        ch.setAttribute('aria-pressed', state[f[0]] === f[1] ? 'true' : 'false');
      });
      var qs = [];
      if (state.subject !== 'all') qs.push('subject=' + encodeURIComponent(state.subject));
      if (state.grade !== 'all') qs.push('grade=' + encodeURIComponent(state.grade));
      history.replaceState(null, '', location.pathname + (qs.length ? '?' + qs.join('&') : ''));
    }

    chips.forEach(function (ch) {
      ch.addEventListener('click', function (e) {
        e.preventDefault();
        var f = ch.getAttribute('data-filter').split(':');
        state[f[0]] = f[1];
        apply();
      });
    });

    apply();
  }

  /* reviews page family filter (same pattern, .review cards) */
  var rwrap = document.querySelector('[data-pp-reviews]');
  if (rwrap) {
    var reviews = [].slice.call(rwrap.querySelectorAll('.review'));
    var rchips = [].slice.call(document.querySelectorAll('.filters .chip[data-rfilter]'));
    var rcount = document.querySelector('[data-pp-rcount]');
    var rstate = new URLSearchParams(location.search).get('f') || 'all';

    function rapply() {
      var shown = 0;
      reviews.forEach(function (c) {
        var fam = c.getAttribute('data-family') || '';
        var ok = rstate === 'all' || fam === rstate;
        c.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      if (rcount) rcount.textContent = shown + ' review' + (shown === 1 ? '' : 's');
      rchips.forEach(function (ch) {
        ch.setAttribute('aria-pressed', ch.getAttribute('data-rfilter') === rstate ? 'true' : 'false');
      });
      history.replaceState(null, '', location.pathname + (rstate === 'all' ? '' : '?f=' + encodeURIComponent(rstate)));
    }

    rchips.forEach(function (ch) {
      ch.addEventListener('click', function (e) {
        e.preventDefault();
        rstate = ch.getAttribute('data-rfilter');
        rapply();
      });
    });

    rapply();
  }

  /* sample-page lightbox (product pages with the custom.sample_pages metafield).
     No external libs. Zoom (click / toggle button), prev/next, keyboard arrows +
     Esc, swipe on touch. Fallback: without the metafield none of this runs. */
  var payload = document.querySelector('script[data-pp-sample-pages]');
  if (payload) {
    var pages = [];
    try { pages = JSON.parse(payload.textContent) || []; } catch (e) { pages = []; }
    if (pages.length) {
      var lb = document.createElement('div');
      lb.className = 'pp-lightbox';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Sample pages');
      lb.hidden = true;
      lb.innerHTML =
        '<button type="button" class="lb-btn lb-close" aria-label="Close (Esc)">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button>' +
        '<button type="button" class="lb-btn lb-prev" aria-label="Previous page">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<div class="lb-stage" tabindex="0"><img alt=""></div>' +
        '<button type="button" class="lb-btn lb-next" aria-label="Next page">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<div class="lb-bar">' +
          '<button type="button" class="lb-btn lb-zoom" aria-pressed="false">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2.2"/><path d="M20.5 20.5 16 16M11 8v6M8 11h6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>' +
            '<span>Zoom</span></button>' +
          '<span class="lb-count" aria-live="polite"></span></div>';
      document.body.appendChild(lb);

      var stage = lb.querySelector('.lb-stage');
      var pic = stage.querySelector('img');
      var count = lb.querySelector('.lb-count');
      var prevB = lb.querySelector('.lb-prev');
      var nextB = lb.querySelector('.lb-next');
      var zoomB = lb.querySelector('.lb-zoom');
      var closeB = lb.querySelector('.lb-close');
      var cur = 0, zoomed = false, opener = null;

      function show(i) {
        cur = Math.max(0, Math.min(pages.length - 1, i));
        pic.src = pages[cur];
        pic.alt = 'Sample page ' + (cur + 1) + ' of ' + pages.length;
        count.textContent = (cur + 1) + ' / ' + pages.length;
        prevB.disabled = cur === 0;
        nextB.disabled = cur === pages.length - 1;
        setZoom(false);
        if (cur + 1 < pages.length) { (new Image()).src = pages[cur + 1]; }
        if (cur > 0) { (new Image()).src = pages[cur - 1]; }
      }
      function setZoom(on, cx, cy) {
        zoomed = !!on;
        lb.classList.toggle('zoomed', zoomed);
        zoomB.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
        if (zoomed) {
          var fx = typeof cx === 'number' ? cx : 0.5;
          var fy = typeof cy === 'number' ? cy : 0.5;
          requestAnimationFrame(function () {
            stage.scrollLeft = pic.clientWidth * fx - stage.clientWidth / 2;
            stage.scrollTop = pic.clientHeight * fy - stage.clientHeight / 2;
          });
        } else { stage.scrollLeft = 0; stage.scrollTop = 0; }
      }
      function open(i, from) {
        opener = from || document.activeElement;
        lb.hidden = false;
        document.documentElement.classList.add('pp-lightbox-open');
        show(i);
        closeB.focus();
      }
      function close() {
        lb.hidden = true;
        document.documentElement.classList.remove('pp-lightbox-open');
        if (opener && opener.focus) { opener.focus(); }
      }

      closeB.addEventListener('click', close);
      prevB.addEventListener('click', function () { show(cur - 1); });
      nextB.addEventListener('click', function () { show(cur + 1); });
      zoomB.addEventListener('click', function () { setZoom(!zoomed); });
      pic.addEventListener('click', function (e) {
        var r = pic.getBoundingClientRect();
        setZoom(!zoomed, (e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height);
      });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target === stage) { close(); } });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) { return; }
        if (e.key === 'Escape') { close(); }
        else if (e.key === 'ArrowLeft') { show(cur - 1); }
        else if (e.key === 'ArrowRight') { show(cur + 1); }
        else if (e.key === 'Tab') {
          var f = [closeB, prevB, nextB, zoomB].filter(function (b) { return !b.disabled; });
          var i = f.indexOf(document.activeElement);
          if (e.shiftKey && (i <= 0)) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
        }
      });
      var tx = null, ty = null;
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length === 1) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (zoomed || tx === null) { return; }
        var dx = e.changedTouches[0].clientX - tx;
        var dy = e.changedTouches[0].clientY - ty;
        tx = ty = null;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.5) { show(dx < 0 ? cur + 1 : cur - 1); }
      }, { passive: true });

      [].slice.call(document.querySelectorAll('.sample-thumb')).forEach(function (b) {
        b.addEventListener('click', function () {
          open(parseInt(b.getAttribute('data-pp-sample-index'), 10) || 0, b);
        });
      });
      [].slice.call(document.querySelectorAll('.pdp-body .prose img')).forEach(function (im) {
        im.classList.add('pp-zoomable');
        im.setAttribute('role', 'button');
        im.setAttribute('tabindex', '0');
        im.setAttribute('aria-label', 'Open the sample pages');
        im.addEventListener('click', function () { open(0, im); });
        im.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(0, im); }
        });
      });
    }
  }
})();
